import { useEffect, useRef, useState } from "react";
import { A, O, pipe, R, S } from "@mobily/ts-belt";
import { phoneFormatter } from "./FormField";
import styles from "./마켓봄_추천하기_Desktop.module.css";

import Image from "next/image";
import { 추천이벤트_목록_PC, type 이벤트기본정보 } from "./데이터/마켓봄_추천하기";
import { match } from "ts-pattern";
import { FormParseSet } from "./api/apiForm";
import { Env } from "./Env";
import { useRouter } from "next/router";

type RecommendationFormProps = {
  recommenderName: string;
  recommenderPhoneNumber: string;
  setRecommenderName: (name: string) => void;
  setRecommenderPhoneNumber: (phone: string) => void;
  recommendeeName: string;
  recommendeePhoneNumber: string;
  setRecommendeeName: (name: string) => void;
  setRecommendeePhoneNumber: (phone: string) => void;
  apply: () => void;
};

const RecommendationForm = ({
  recommenderName,
  recommenderPhoneNumber,
  setRecommenderName,
  setRecommenderPhoneNumber,
  recommendeeName,
  recommendeePhoneNumber,
  setRecommendeeName,
  setRecommendeePhoneNumber,
  apply
}: RecommendationFormProps) => (
  <div style={{backgroundColor: "#FFFFFF"}}>
    <div className={styles["section-area"]}>
      <div className={styles["insert-area"]}>
        <div className={styles["title"]}>추천하는 분과 추천받는 분의 연락처를 입력해주세요.</div>
        <div className={styles["area-table"]}>
          <div className={styles["area-box"]}>
            <div className={styles["sub-title"]}>추천하는 분</div>
            <div className={styles["row"]}>
              <span style={{ width: "78px", marginLeft: "30px" }}>
                <strong className={styles["label"]}>이름</strong>
              </span>
              <span className="col">
                <label>
                  <input
                    type="text"
                    placeholder="이름을 입력해주세요."
                    value={recommenderName}
                    onChange={(e) => setRecommenderName(e.target.value)}
                  />
                </label>
              </span>
            </div>
            <div className={styles["row"]}>
              <span style={{ width: "78px", marginLeft: "30px" }}>
                <strong className={styles["label"]}>연락처</strong>
              </span>
              <span className="col">
                <label>
                  <input
                    type="text"
                    placeholder="‘-’없이 숫자만 입력해주세요."
                    value={recommenderPhoneNumber}
                    onChange={(e) => setRecommenderPhoneNumber(pipe(e.target.value, phoneFormatter))}
                  />
                </label>
              </span>
            </div>
          </div>
          <div className={styles["area-box"]} style={{ marginLeft: "20px" }}>
            <div className={styles["sub-title"]}>추천받는 분</div>
            <div className={styles["row"]}>
              <span style={{ width: "78px", marginLeft: "30px" }}>
                <strong className={styles["label"]}>이름</strong>
              </span>
              <span className="col">
                <label>
                  <input
                    type="text"
                    placeholder="이름을 입력해주세요."
                    value={recommendeeName}
                    onChange={(e) => setRecommendeeName(e.target.value)}
                  />
                </label>
              </span>
            </div>
            <div className={styles["row"]}>
              <span style={{ width: "78px", marginLeft: "30px" }}>
                <strong className={styles["label"]}>연락처</strong>
              </span>
              <span className="col">
                <label>
                  <input
                    type="text"
                    placeholder="‘-’없이 숫자만 입력해주세요."
                    value={recommendeePhoneNumber}
                    onChange={(e) => setRecommendeePhoneNumber(pipe(e.target.value, phoneFormatter))}
                  />
                </label>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className={styles["btn-recommend"]}>
        <button
          type="button"
          className={styles["btn-send"]}
          onClick={() => apply()}
        >
              추천하기
        </button>
      </div>
    </div>
  </div>
);

type 추천이벤트Props = {
  추천이벤트: 이벤트기본정보;
};

const ImageSection_Row = ({추천이벤트}: 추천이벤트Props) => {
  const {바탕색, 높이, 이미지} = 추천이벤트;
  return(
    <>
      <div style={{ backgroundColor: `${바탕색}`, height: `${높이}` }}>
        <div className={styles["image-area"]}>
          <Image src={이미지} alt={""} priority fetchPriority={"high"} width={1440} />
        </div>
      </div>
    </>
  );
};

const ImageSection = () => {
  return (
    <>
      {pipe(
        추천이벤트_목록_PC,
        A.map((이벤트이미지) => (
          <ImageSection_Row key={이벤트이미지.이름} 추천이벤트={이벤트이미지} />
        ))
      )}
    </>
  );
};

// const generateLink = (recommenderPhoneNumber: string) => {
//   return `${Env.HOME_URL}/features?no=${btoa(recommenderPhoneNumber)}`;
// };

// const shareKakao = (recommenderPhoneNumber: string) => {
//   const link = generateLink(recommenderPhoneNumber);
//   try {
//     global.window.Kakao.Link.sendDefault({
//       installTalk: true,
//       objectType: "text",
//       text: "안녕하세요! 수발주 프로그램 마켓봄입니다.\n매일 받는 주문 취합, 아직도 직접 입력하세요?\n늘어나는 미수금, 관리하기 어렵지 않으신가요?\n\n수발주 프로그램을 도입으로 유통업무를 편리하게 바꿔보세요!",
//       link: {
//         mobileWebUrl: link,
//         webUrl: link,
//       },
//       buttons: [],
//     });
//   } catch (error) {
//     console.error(error);
//   }
// };

// const shareLink = (recommenderPhoneNumber: string) => {
//   const link = generateLink(recommenderPhoneNumber);
//   navigator.clipboard.writeText(`안녕하세요! 수발주 프로그램 마켓봄입니다.\n매일 받는 주문 취합, 아직도 직접 입력하세요?\n늘어나는 미수금, 관리하기 어렵지 않으신가요?\n\n수발주 프로그램을 도입으로 유통업무를 편리하게 바꿔보세요!\n${link}`);
//   alert("링크 복사가 완료되었습니다.");
// };

// const RecommendSection = ({
//   setShowPopupFn,
//   recommenderPhoneNumber
// }: RecommendationPopupProps) => {
//   return (
//     <>
//       <div className={styles["popup-area"]}>
//         <div className={styles["close-button"]}>
//           <button
//             type="button"
//             style={{
//               width: "24px",
//               height: "24px",
//               background: `url(${닫기_아이콘.src}) no-repeat center center`,
//               zIndex: 1,
//             }}
//             onClick={() => {
//               setShowPopupFn(false);
//             }}
//           />
//         </div>
//         <div className={styles["title"]}>유통사나 프랜차이즈 본사에</div>
//         <div className={styles["title"]}><span className={styles["b"]}>마켓봄을 공유</span>해주세요!</div>
//         <div className={styles["link-area"]}>
//           <div className={styles["link-button"]} onClick={() => shareKakao(recommenderPhoneNumber)}>
//             <Image src={공유_PC[0] ?? ""} alt={""} priority fetchPriority={"high"} width={80} height={80} />
//             <div className={styles["link-text"]}>카카오톡 공유</div>
//           </div>
//           <div className={styles["link-button"]} onClick={() => shareLink(recommenderPhoneNumber)}>
//             <Image src={공유_PC[1] ?? ""} alt={""} priority fetchPriority={"high"} width={80} height={80} />
//             <div className={styles["link-text"]}>링크 공유하기</div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

const NoticeSection = () => {
  return (
    <div style={{ background: "#605D68" }}>
      <div className="section">
        <dt>
          <div style={{ display: "flex", alignItems: "center" }}>
            유의사항
          </div>
        </dt>
        <dd>
          <ul>
            <li>본 이벤트는 당사 사정에 따라 별도 공지 없이 변경 또는 종료될 수 있습니다.</li>
            <li>휴대전화 번호 오기재 및 변경으로 인한 누락은 책임지지 않습니다.</li>
            <li>상품권의 유효기간은 1개월이며, 추천받은 분이 마켓봄 사용 확정 이후 지급됩니다.</li>
            <li>5만 원 상품권은 첫째 주 수요일에 발송됩니다.</li>
          </ul>
        </dd>      
      </div>
    </div>
  );
};

export const 마켓봄_추천하기_Desktop = () => {
  const [recommenderName, setRecommenderName] = useState("");
  const [recommenderPhoneNumber, setRecommenderPhoneNumber] = useState("");
  const [recommendeeName, setRecommendeeName] = useState("");
  const [recommendeePhoneNumber, setRecommendeePhoneNumber] = useState("");
  const router = useRouter();
  const isLoading = useRef(false);

  useEffect(() => {
    if (router.query["origin"]) {
      fetch(`${Env.BSS_ENTRYPOINT}/public/partner-company`, {
        method: "POST",
        headers: {
          hash: "$2b$10$ehYj3E9rJH7S1KuWwwF3xOdh/d13XPmkIfJgqpWBrxMsx/mggk2JC",
          api_identify_email: "marketbom",
        },
        body: new URLSearchParams({
          path: router.query["origin"].toString(),
          classification: "LINKEDIN_PROMOTION",
        }),
      });
    }
  },[router]);
  
  const apply = async () => {
    const [recommenderName_, recommenderPhoneNumber_, recommendeeName_, recommendeePhoneNumber_] = pipe(
      [recommenderName, recommenderPhoneNumber, recommendeeName, recommendeePhoneNumber],
      A.map(S.trim),
      A.toTuple
    );

    // 4개의 값 중 하나라도 비어 있으면 메시지 출력
    const isAnyFieldEmpty = [recommenderName_, recommenderPhoneNumber_, recommendeeName_, recommendeePhoneNumber_].some(
      (value) => value === ""
    );
  
    if (isAnyFieldEmpty) {
      alert("모든 정보를 입력해주세요.");
      return;
    }

    match(
      [
        FormParseSet["validName"](recommenderName_ ?? ""),
        FormParseSet["phone"](recommenderPhoneNumber_ ?? ""),
        FormParseSet["validName"](recommendeeName_ ?? ""),
        FormParseSet["phone"](recommendeePhoneNumber_ ?? ""),
      ] as [
        R.Result<string, string>,
        R.Result<string, string>,
        R.Result<string, string>,
        R.Result<string, string>
      ]
    ).with(
      [{ TAG: 0 }, { TAG: 0 }, { TAG: 0 }, { TAG: 0 }],

      async ([recommenderName, recommenderPhoneNumber, recommendeeName, recommendeePhoneNumber]) => {
        const body = new URLSearchParams();
        body.append("byName", recommenderName._0 ?? "");
        body.append("byPhoneNumber", recommenderPhoneNumber._0 ?? "");
        body.append("withName", recommendeeName._0 ?? "");
        body.append("withPhoneNumber", recommendeePhoneNumber._0 ?? "");
        isLoading.current = true;
        fetch("/api/linkedIn", {
          method: "POST",
          body,
        })
          .then((response) => {
            if (response.ok) {
              return response.json();
            } else {
              throw new Error(
                "현재 추천 신청이 어려워 전화를 주시면 빠른 안내 해드리겠습니다."
              );
            }
          })
          .then(
            () => {
              alert("추천이 완료되었습니다.");
              setRecommendeeName("");
              setRecommendeePhoneNumber("");
            },
            (error) => {
              alert(error.message);
            }
          )
          .finally(() => {
            isLoading.current = false;
          });

        fetch(`${Env.BSS_ENTRYPOINT}/public/partner-company`, {
          method: "POST",
          headers: {
            hash: "$2b$10$ehYj3E9rJH7S1KuWwwF3xOdh/d13XPmkIfJgqpWBrxMsx/mggk2JC",
            api_identify_email: "marketbom",
          },
          body: new URLSearchParams({
            path: "LINKEDIN_CLICK",
            classification: "LINKEDIN_PROMOTION",
          }),
        });
      } 
    )
      .otherwise(([recommenderName, recommenderPhoneNumber, recommendeeName, recommendeePhoneNumber]) => {
        const invalidPhoneMessage = pipe(
          [
            FormParseSet["phone"](recommenderPhoneNumber._0 ?? ""),
            FormParseSet["phone"](recommendeePhoneNumber._0 ?? "")
          ],
          A.filter(R.isError),
          (errors) => (A.isEmpty(errors) ? "" : "연락처가 유효하지 않습니다"),
          O.getWithDefault("")
        );

        const invalidNameMessage = pipe(
          [
            FormParseSet["validName"](recommenderName._0 ?? ""),
            FormParseSet["validName"](recommendeeName._0 ?? "")
          ],
          A.filter(R.isError),
          (errors) => (A.isEmpty(errors) ? "" : "이름이 유효하지 않습니다"),
          O.getWithDefault("")
        );
        
        const message = pipe(
          [invalidNameMessage, invalidPhoneMessage],
          A.join("\n\n")
        );
        
        alert(`${message}`);
      })
    ;
  };

  return (
    <div className="linkedin">
      <ImageSection />
      <RecommendationForm
        recommenderName={recommenderName}
        setRecommenderName={setRecommenderName}
        recommenderPhoneNumber={recommenderPhoneNumber}
        setRecommenderPhoneNumber={setRecommenderPhoneNumber}
        recommendeeName={recommendeeName}
        setRecommendeeName={setRecommendeeName}
        recommendeePhoneNumber={recommendeePhoneNumber}
        setRecommendeePhoneNumber={setRecommendeePhoneNumber}
        apply={apply}
      />
      <NoticeSection />
    </div>
  );
};
